<section class="approver-container">
  <span>Approvers</span>

  <div class="sub-container">
    <div class="header-row">
      <span>Name, Title</span>
      <span style="padding-right: 7rem">DOA Authority Amount</span>
    </div>
    @for (approver of approverList || []; track approver; let i = $index) {
      <div class="approver-row">
        <mat-form-field class="approver-input">
          <input
            [name]="autocompleteName(i)"
            type="text"
            matAutocompletePosition="below"
            matInput
            [matAutocomplete]="auto1"
            [formControl]="additionalApproverControl[i]"
            [(ngModel)]="additionalApprovers[i]"
            (keydown.enter)="
              $event.stopPropagation(); searchUsersAdditionalApprover($event.target.value, i)
            "
            required
            [name]="'additionalApprover' + i"
            [disabled]="reviewMode"
          />
          @if (additionalApprovers[i] && additionalApprovers[i].displayName && !reviewMode) {
            <div style="z-index: 0; position: absolute; right: 4px; top: 5px">
              <img
                (click)="deleteAdditionalApproverValue(i)"
                style="cursor: pointer"
                src="assets/close-window.svg"
              />
            </div>
          }
        </mat-form-field>
        <mat-autocomplete
          #auto1="matAutocomplete"
          [displayWith]="displayFnAdditionalApprover"
          (optionSelected)="additionalApproverSelected($event.option.value, i)"
        >
          @for (option of additionalApproverOptions[i]; track option) {
            <mat-option style="color: #696969" [value]="option">
              @if (option.givenName && option.surname && option.jobTitle) {
                <span
                  >{{ option.givenName }} {{ option.surname }} ({{ option.mail }}),
                  {{ option.jobTitle }}</span
                >
              }
              @if (option.givenName && option.surname && !option.jobTitle) {
                <span>{{ option.givenName }} {{ option.surname }} ({{ option.mail }})</span>
              }
              @if (!(option.givenName && option.surname) && option.jobTitle) {
                <span>{{ option.displayName }} ({{ option.mail }}), {{ option.jobTitle }}</span>
              }
              @if (!(option.givenName && option.surname) && !option.jobTitle) {
                <span>{{ option.displayName }} ({{ option.mail }})</span>
              }
            </mat-option>
          }
        </mat-autocomplete>
        @if (!reviewMode) {
          <button
            class="button-primary"
            style="width: 5rem !important"
            type="button"
            (click)="searchUsersAdditionalApprover(additionalApprovers[i], i)"
          >
            <span class="confirmText">SEARCH</span>
          </button>
        }
        <span style="width: 17%; text-align: center"
          >${{ (doaAmounts[i + 1] || 0).toLocaleString('en', { useGrouping: true }) }}</span
        >
        @if (!reviewMode) {
          <img
            style="cursor: pointer; width: 1rem; height: 1rem; position: relative; top: -1px"
            src="assets/trash-bin-base.svg"
            (click)="deleteApprover(i)"
          />
        }
      </div>
    }

    @if ((approverList || []).length > 0 && !doaAmountMet()) {
      <div style="padding-left: 1.5rem; background-color: #f3fafd">
        <div style="width: 31rem">
          <span style="color: #9e1b32; font-size: 0.875rem"
            >Warning: DOA amount is not high enough. Please add approver.</span
          >
        </div>
      </div>
    }
    @if (!reviewMode) {
      <div class="add-approver-section" (click)="addNewAdditionalApprover()">
        <span style="font-weight: bold; font-size: 1.4rem">&#43;</span>
        <span
          style="padding-left: 0.2rem; text-decoration: underline; text-underline-offset: 0.2rem"
          >Add Another Approver</span
        >
      </div>
    }
  </div>
</section>
